import { Button, createStyles, Progress, Space, Text } from "@mantine/core";
import React from "react";
import { CSVLink } from "react-csv";
import ErrorPage from "../../../common/pages/ErrorPage";
import ProgressIndicator from "../../../themes/components/ProgressIndicator";
import useAnnouncementStatsApiService from "../services/api/AnnouncementStatsApiService";

type AnnouncementStatsCardType = {
  announcementId: number;
};

const useStyles = createStyles((theme) => ({
  progressLabel: {
    fontFamily: `Inter, ${theme.fontFamily}`,
    lineHeight: 1,
    fontSize: theme.fontSizes.sm,
  },
}));

const AnnouncementStatsCard: React.FC<AnnouncementStatsCardType> = ({
  announcementId,
}) => {
  const { classes } = useStyles();
  const { isLoading, isError, error, data } =
    useAnnouncementStatsApiService(announcementId);

  if (isLoading) {
    return <ProgressIndicator />;
  }

  if (isError) {
    return <ErrorPage errors={error} />;
  }

  const csvData = [
    ["Announcements sent", "Announcements viewed", "Notifications seen"],
    [
      data?.notification_sent_count,
      data?.reads_on_view_announcement_count,
      data?.notification_read_count,
    ],
  ];

  const calculatePercentage = (value: number, total: number): number =>
    parseFloat(((100 * value) / total).toFixed(2));

  return data ? (
    <>
      <Text>
        {`${data.notification_sent_count} Notification${
          data.notification_sent_count !== 1 ? "s" : ""
        } sent`}
      </Text>
      <Progress
        size={34}
        value={data.notification_sent_count > 0 ? 100 : 0}
        classNames={{ label: classes.progressLabel }}
        mt={34}
        color="#bbf2e2"
      />
      <Space h="md" />
      <Text>
        {`${data.reads_on_view_announcement_count} Announcement${
          data.reads_on_view_announcement_count !== 1 ? "s" : ""
        } viewed`}
      </Text>
      <Progress
        size={34}
        value={calculatePercentage(
          data.reads_on_view_announcement_count,
          data.notification_sent_count
        )}
        classNames={{ label: classes.progressLabel }}
        mt={34}
        color="#cfedfc"
      />

      <Space h="md" />
      <Text>
        {`${data.notification_read_count} Notification${
          data.notification_read_count !== 1 ? "s" : ""
        } seen`}
      </Text>
      <Progress
        size={34}
        classNames={{ label: classes.progressLabel }}
        value={calculatePercentage(
          data.notification_read_count,
          data.notification_sent_count
        )}
        mt={34}
        color="#fff3c4"
      />

      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Button fullWidth type="button" variant="default" color="jem-theme">
        <CSVLink data={csvData} filename={`announcement_${announcementId}`}>
          Download CSV
        </CSVLink>
      </Button>
    </>
  ) : (
    <div />
  );
};

export default AnnouncementStatsCard;
